import React, { useState, useRef, useEffect } from 'react';
import { FaChevronRight } from 'react-icons/fa';

import '../styles/Home.css';
import '../styles/Contact.css';

import Footer from '../components/Footer.js'
import axiosPost from '../helper/axios-helper';

export default function Contact() {
    const [view, setView] = useState('contact');
    const [selectedFAQ, setSelectedFAQ] = useState(0);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitMessage, setSubmitMessage] = useState('');
    const [faqs, setFaqs] = useState([
        {
            id: 1,
            question: "What is CANTO?",
            answer: "CANTO stands for Caribbean Association of National Telecommunication Organizations. It is a trade association representing telecom operators in the Caribbean region, promoting collaboration and innovation in the telecommunications and ICT sector"
        },
        {
            id: 2,
            question: "What is the mission of CANTO?",
            answer: "CANTO's mission is to influence the innovation and development of ICT solutions for the benefit of members by developing and guiding policy positions in collaboration with stakeholders, advocating on behalf of members in international forums, and driving the deployment of innovative and advanced services to improve the lives of Caribbean people."
        },
        {
            id: 3,
            question: "Who can become a member of CANTO?",
            answer: "CANTO offers various membership categories including Full members (telecom providers), Affiliate members (suppliers of telecom/ICT equipment and services), Associate members (regulators and government ministries), and Academia members (educational institutions)."
        },
        {
            id: 4,
            question: "What events does CANTO organize?",
            answer: "CANTO organizes several key events, including the Annual Conference & Trade Exhibition, which brings together ICT professionals, regulators, and stakeholders from across the Caribbean and beyond. They also host ministerial roundtables, technical workshops, and other industry-specific gatherings."
        },
        {
            id: 5,
            question: "How does CANTO support the Caribbean ICT sector?",
            answer: "CANTO supports the sector through policy advocacy, facilitating knowledge sharing and best practices, organizing networking events, providing training and development opportunities, and fostering partnerships between members and industry stakeholders."
        },
        {
            id: 6,
            question: "How can I stay updated on CANTO's activities?",
            answer: "You can stay updated by visiting the CANTO website regularly, following their social media channels, subscribing to their newsletter, or becoming a member to receive direct communications and invitations to events."
        }
    ])

    const faqRefs = useRef({});

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = () => {
        // Validate form
        if (!formData.name || !formData.email || !formData.phone || !formData.message) {
            setSubmitMessage('Please fill in all fields.');
            return;
        }

        // Validate email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            setSubmitMessage('Please enter a valid email address.');
            return;
        }

        setIsSubmitting(true);
        setSubmitMessage('');

        axiosPost('contact/submit', formData, {}, (data) => {
            const { success, response } = data;
            setIsSubmitting(false);
            
            if (success) {
                setSubmitMessage('Thank you! Your message has been sent successfully.');
                // Reset form
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    message: ''
                });
            } else {
                setSubmitMessage(response || 'An error occurred. Please try again.');
            }
        });
    };

    useEffect(() => {
        Object.keys(faqRefs.current).forEach(id => {
            const el = faqRefs.current[id];
            if (el) {
                el.style.maxHeight = selectedFAQ == id ? `${el.scrollHeight}px` : '0px';
            }
        });
    }, [selectedFAQ]);

    function renderFAQS() {

        const render_faqs = faqs.map((faq, index) => 
            <div className='faq-item' onClick={() => {
                setSelectedFAQ(prevId => prevId == faq.id ? null : faq.id);
            }}>
                <div className='faq-item-title'>
                    {faq.question}
                    <div className='faq-item-icon-container'>
                        <div className='faq-bar'></div>
                        <div className='faq-bar rotate' style={{rotate: (selectedFAQ == faq.id) ? '0deg' : '90deg'}}></div>
                    </div>
                </div>
                <div className='faq-item-text' 
                ref={el => faqRefs.current[faq.id] = el}
                style={{
                    maxHeight: '0px',
                    overflow: 'hidden',
                    transition: 'max-height 0.3s ease-in-out'
                }}>
                    {faq.answer}
                </div>
                
            </div>
        )

        return render_faqs;
    }

    function renderContent(){

        
        switch (view) {
            case 'contact':
                return (
                    <div className='contact-form'>
                        <div className='contact-form-title'>Name</div>
                        <input 
                            className='contact-form-input' 
                            type='text' 
                            name='name'
                            value={formData.name}
                            onChange={handleInputChange}
                            placeholder='Enter your Name...'
                        />

                        <div className='contact-form-title'>Email</div>
                        <input 
                            className='contact-form-input' 
                            type='email' 
                            name='email'
                            value={formData.email}
                            onChange={handleInputChange}
                            placeholder='Enter your E-mail...'
                        />

                        <div className='contact-form-title'>Phone/Mobile number</div>
                        <input 
                            className='contact-form-input' 
                            type='text' 
                            name='phone'
                            value={formData.phone}
                            onChange={handleInputChange}
                            placeholder='Enter your Phone Number...'
                        />

                        <div className='contact-form-title'>Message</div>
                        <textarea 
                            className='contact-form-input area' 
                            name='message'
                            value={formData.message}
                            onChange={handleInputChange}
                            placeholder='Enter your message...'
                        />

                        {submitMessage && (
                            <div style={{
                                padding: '10px',
                                marginTop: '10px',
                                borderRadius: '4px',
                                backgroundColor: submitMessage.includes('success') ? '#d4edda' : '#f8d7da',
                                color: submitMessage.includes('success') ? '#155724' : '#721c24',
                                border: `1px solid ${submitMessage.includes('success') ? '#c3e6cb' : '#f5c6cb'}`
                            }}>
                                {submitMessage}
                            </div>
                        )}

                        <div className='contact-form-btn-container'>
                            <div 
                                className='contact-form-btn'
                                onClick={handleSubmit}
                                style={{
                                    opacity: isSubmitting ? 0.6 : 1,
                                    cursor: isSubmitting ? 'not-allowed' : 'pointer'
                                }}
                            >
                                {isSubmitting ? 'Sending...' : 'Send'}
                                <div className='contact-form-btn-icon'>
                                    <FaChevronRight size={16} color='#fff'/>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            break; 

            case 'faq':
                return (
                    <div className='faq-container'>
                        <div className='faq-title'>Frequently Asked Questions</div>
                        <div className='faq-wrapper'>
                            {renderFAQS()}
                        </div>
                    </div>
                )
            break; 
        }
        
        return false;
    }

  return (
    <div className='container'>
        <div className='contact-header-container'>
            <div className='contact-header-title'>Contact <span>Us</span></div>
            <div className='contact-header-subtitle'>Get in Touch with Our Team</div>
        </div>
        <div className='contact-content-container'>
            <div className='contact-sidebar'>
                <div className='contact-sidebar-option' onClick={() => {setView('contact')}}>
                    Contact
                    <div className='contact-sidebar-option-bar' style={{width:(view == 'contact') ? '100%' : '0%'}}></div>
                </div>
                <div className='contact-sidebar-option' onClick={() => {setView('faq')}}>
                    FAQ
                    <div className='contact-sidebar-option-bar' style={{width:(view == 'faq') ? '100%' : '0%'}}></div>
                </div>
            </div>

            <div className='contact-content'>
                {renderContent()}
            </div>

            <div className='contact-information-container'>
                <div className='contact-information-item'>
                    <div className='contact-information-title'>Our Address</div>
                    <div className='contact-information-text'>67 Picton Street</div>
                    <div className='contact-information-text'>Newtown</div>
                    <div className='contact-information-text'>Port-of-Spain</div>
                    <div className='contact-information-text'>Trinidad</div>
                </div>
                <div className='contact-information-item'>
                    <div className='contact-information-title'>Our Information</div>
                    <div className='contact-information-text'>+1-868-622-3770</div>
                    <div className='contact-information-text'> canto@canto.org	</div>
                </div>
                <div className='contact-information-item'>

                </div>
            </div>
        </div>

    </div>
  )
}
